(function() {
    'use strict';

    angular
        .module('app.nacionalidades')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/nacionalidades',
                config: {
                    templateUrl: 'app/nacionalidades/nacionalidades.html',
                    controller: 'Nacionalidades',
                    controllerAs: 'vm',
                    title: 'Nacionalidades'
                }
            },
            {
                url: '/editar-nacionalidad/:id?',
                config: {
                    templateUrl: 'app/nacionalidades/editarNacionalidad.html',
                    controller: 'EditarNacionalidad',
                    controllerAs: 'vm',
                    title: 'EditarNacionalidad'
                }
            }
        ];
    }
})();
